import { render, staticRenderFns } from "./ReportUser.vue?vue&type=template&id=6d819c4b&"
import script from "./ReportUser.vue?vue&type=script&lang=js&"
export * from "./ReportUser.vue?vue&type=script&lang=js&"
import style0 from "./ReportUser.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports